module.exports = __webpack_public_path__ + "static/media/docs.d037c35a.png";